export default __webpack_public_path__ + "static/media/thumbnail.197a6634.png";